import styles from './UserRegistration.scss';
import Footer from 'main/components/Footer';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { isEmpty, get } from 'lodash';
import { registerUser } from 'common/actions/login';

class UserRegistration extends Component {
    componentDidMount() {
        this.redirectToOverview(this.props);
    }

    componentWillReceiveProps(nextProps){
        this.redirectToOverview(nextProps);
    }

    redirectToOverview(props){
        const { dispatch } = this.context.store;
        const { nonce, email } = get(props, 'location.query', {});

        if(!isEmpty(get(props, 'me', null))){
            dispatch(replace('/binders'));
        }
        else if (isEmpty(nonce) || isEmpty(email)) {
            dispatch(replace('/'));
        }
    }

    registerUser(e){
        e.preventDefault();
        const { location, registerUser } = this.props;
        const { nonce, email } = get(location, 'query', {});
        if (isEmpty(nonce) || isEmpty(email)) {
            return;
        }
        registerUser(nonce, email);
    }

    render() {
        return (
            <div className={styles.container} data-cy="UserRegistration">
                <div className={styles.content}>
                    <span className={styles.logo}></span>

                    <p className={styles.welcomeText}>
                        Welcome to Complion, your eRegulatory solution empowering clinical research sites. Click the button below to start setting up your account.
                    </p>

                    <span className={styles.loginButton}>
                        <a href="#login" onClick={this.registerUser.bind(this)} className={styles.loginLink} data-cy="UserRegistration-login">
                            Set Up Your Account
                        </a>
                    </span>
                </div>
                <Footer />
            </div>
        );
    }
}

UserRegistration.contextTypes = {
    store: PropTypes.any
};

export default connect((state) => {
    return {
        me: get(state, 'me', {})
    };
}, {
    registerUser
})(UserRegistration);

